import React, { useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';
import BreadCrumb from '../../../Common/BreadCrumb';

//import Components
import { useDispatch } from 'react-redux';
import { setProductCurrentStep, setProductInfoFromApi } from '../../../Redux/ProductSlice';
import ProductFilter from './ProductFilter';

const ListView = () => {
    document.title = "Product List | Toner eCommerce + Admin React Template";
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setProductCurrentStep('STEP1'))
        dispatch(setProductInfoFromApi({}))
    }, []);


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Product List" pageTitle="Products" />
                    <Row>
                       
                        <ProductFilter />
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ListView;
